import React, { useRef, useState } from 'react';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css';

import "../css/ArtworkSwiper.css"


import { Keyboard, Pagination, Navigation } from 'swiper/modules';
import PhotoModal from "./PhotoModal";


export default function ArtworkSwiper({ artworks }) {
    const [selectedIndex, setSelectedIndex] = useState(null);

    return (
        <>
        <Swiper
            slidesPerView="auto"
            spaceBetween={20}
            pagination={{ clickable: true }}
            navigation={true}
            keyboard={{enabled: false}}
            modules={[Keyboard, Pagination, Navigation]}
            className="mySwiper"
            onSwiper={(swiper) => {
                const enter = () => swiper.keyboard.enable();
                const leave = () => swiper.keyboard.disable();
                swiper.el.addEventListener('mouseenter', enter);
                swiper.el.addEventListener('mouseleave', leave);
                swiper.on('destroy', () => {
                    swiper.el.removeEventListener('mouseenter', enter);
                    swiper.el.removeEventListener('mouseleave', leave);
                });
            }}
        >
            {artworks.map((art, idx) => (
                <SwiperSlide key={idx}>
                    <button
                        onClick={() => setSelectedIndex(idx)}
                    >
                        <img loading="lazy" src={art.src} alt={art.name} />
                    </button>
                </SwiperSlide>
            ))}
            </Swiper>
            <PhotoModal
                photos={artworks}
                selectedIndex={selectedIndex}
                onClose={() => setSelectedIndex(null)}
            />
        </>
    
    );
}
